module.exports = __webpack_public_path__ + "img/fruits.3fa0f7a6.png";